
<common-navigation [disabledLink]="disabledLink"></common-navigation>

<div class="container-fluid">
    <div class="row no-gutter">
        <div class="col-md-12 col-lg-4">
            <div class="default-box long-form d-flex">
                <div class="container">
                    <div class="row daddress-side-nav">
                        <div class="col-md-12" id="side-nav">
                            <div class="alert alert-warning alert-dismissible fade show" role="alert" 
                                *ngIf="error">
                                {{ errorMsg }}
                            </div>
                            <h3 class="display-4 box-title">Delivery Address</h3> <br>
                            <form [formGroup]="addressForm" (ngSubmit)="onSubmit()">
                                <div class="md-input">
                                    <input 
                                        class="md-form-control" 
                                        required 
                                        type="text"
                                        formControlName="line1"
                                        [ngClass]="{'error': (submitted && addressForm.invalid && f.line1.invalid) || (f.line1.dirty && f.line1.invalid)}"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>Street Address 1*</label>
                                </div>
                                <div class="md-input">
                                    <input 
                                        class="md-form-control" 
                                        required
                                        type="text"
                                        [(ngModel)]="line2" [ngModelOptions]="{standalone: true}"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>Street Address 2</label>
                                </div>
                                <div class="md-input">
                                    <input 
                                        class="md-form-control" 
                                        required 
                                        type="text"
                                        formControlName="suburb"
                                        [ngClass]="{'error': (submitted && addressForm.invalid && f.suburb.invalid) || (f.suburb.dirty && f.suburb.invalid)}"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>Suburb*</label>
                                </div>
                                <div class="md-input">
                                    <input 
                                        class="md-form-control" 
                                        required 
                                        type="text"
                                        formControlName="city"
                                        [ngClass]="{'error': (submitted && addressForm.invalid && f.city.invalid) || (f.city.dirty && f.city.invalid)}"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>City*</label>
                                </div>
                                <div class="md-input post-code">
                                    <input 
                                        class="md-form-control" 
                                        required 
                                        type="text"
                                        formControlName="postcode"
                                        [ngClass]="{'error': (submitted && addressForm.invalid && f.postcode.invalid) || (f.postcode.dirty && f.postcode.invalid)}"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>Post Code*</label>
                                </div>
                                <div>
                                    <select 
                                        class="country-select form-control" 
                                        [ngClass]="{'error': countryError}"
                                    >   
                                        <option selected=""></option>
                                        <option *ngFor="let data of countries" [value]="data.id">{{ data.value }}</option>
                                    </select>
                                    <label class="countryLabel" *ngIf="showCountryLabel">Country</label>
                                </div>
                                

                                <button type="submit" class="btn btn-primary btn-block btn-submit mt-md-5 mt-5" [disabled]="disabledButton">
                                    Continue
                                    <img src="../../../../assets/images/loader.gif" *ngIf="loading">
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-8 d-none d-lg-flex default-box bg-image"></div>
    </div>
</div>
